import { render } from "./YouTubeAttribution.vue?vue&type=template&id=7f3b7802"
const script = {}

import "./YouTubeAttribution.vue?vue&type=style&index=0&id=7f3b7802&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__